;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .constant('VULN_DISCUSSION_EVENTS', {
      DELETE: 'trace.discussion.delete',
      ADD: 'trace.discussion.add'
    })
})()
